import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from './lang.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
  private static readonly APPEARANCE_DEFAULTS = {
    font: 'Nunito Sans',
    primaryText: '#333333',
    secondaryText: '#808080',
    buttonText: '#FFFFFF',
    gradientFallbackStart: '#0879C5',
    gradientFallbackEnd: '#00C6FF',
  } as const;

  /** Matches hex / rgb(a) tokens inside gradient() strings */
  private static readonly GRADIENT_COLOR_TOKEN =
    /(#[0-9A-Fa-f]{3,8}|rgba?\([^)]+\))/gi;

  private subscriptions: Subscription;

  constructor(public translate: TranslateService,
    private langSer:LangService,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.subscriptions = this.langSer.getData().subscribe(value => {
      const Lang = value;
      this.translate.use(Lang);
      });
   }

  contactLabelConversion(key: string,langCode?:string) {
    if (!key || typeof key !== 'string') {
      return '';
    }

    const normalizedKey = key.trim().toLowerCase();
    if (!normalizedKey || normalizedKey === 'none') {
      return '';
    }

    let key1: string = '';
    switch (normalizedKey) {
      case 'telephone':
        key1 = "CARDADD.GENERAL.TELEPHONE";
        break;
      case 'mobile':
        key1 = "CARDADD.GENERAL.MOBILE";
        break;
      case 'fax':
        key1 = "CARDADD.GENERAL.FAX";
        break;
      case 'work':
        key1 = "CARDADD.GENERAL.WORK";
        break;
      case 'personal':
        key1 = "CARDADD.GENERAL.PERSONAL";
        break;
      case 'office':
        key1 = "CARDADD.GENERAL.OFFICE";
        break;
      case 'main':
        key1 = "CARDADD.GENERAL.MAIN";
        break;
      case 'direct':
        key1 = "CARDADD.GENERAL.DIRECT";
        break;
      case 'stores':
        key1 = "CARDADD.GENERAL.STORES";
        break;
      case 'support':
        key1 = "CARDADD.GENERAL.SUPPORTS";
        break;
      case 'toll free':
        key1 = "CARDADD.GENERAL.TOLLFREE";
        break;
      case 'showroom':
        key1 = "CARDADD.GENERAL.SHOWROOM";
        break;
      case 'customer service':
        key1 = "CARDADD.GENERAL.CUSTOMERSERVICE";
        break;
      case 'factory':
        key1 = "CARDADD.GENERAL.FACTORY";
        break;
      case 'sales':
        key1 = "CARDADD.GENERAL.SALES";
        break;
      case 'service center':
        key1 = "CARDADD.GENERAL.SERVICECENTER";
        break;
    }

    // For non-predefined/custom labels, return the raw label instead of translating.
    if (!key1) {
      return key.trim();
    }

    return this.translate.instant(key1, { lang: langCode })
  }

  renderAddress(objAddress: any) {
    let address = '';
    // if (objAddress.doorno && objAddress.doorno != '' && objAddress.doorno != null) {
    //   address += objAddress.doorno ;
    // }
    if (objAddress.address1 && objAddress.address1 != '' && objAddress.address1 != null) {
      address += objAddress.address1;
    }
    if (objAddress.address2 && objAddress.address2 != '' && objAddress.address2 != null) {
      address += ', ' + objAddress.address2;
    }
    // if (objAddress.landmark && objAddress.landmark != '' && objAddress.landmark != null) {
    //   address +=objAddress.landmark ;
    // }
    if (objAddress.city && objAddress.city != '' && objAddress.city != null) {
      address += ', ' + objAddress.city;
    }
    if (objAddress.state && objAddress.state != '' && objAddress.state != null) {
      address += ', ' + objAddress.state;
    }
    if (objAddress.country && objAddress.country != '' && objAddress.country != null && objAddress.country != undefined) {
      address += ', ' + objAddress.country;
    }
    if (objAddress.postalcode && objAddress.postalcode != '' && objAddress.postalcode != null) {
      address += ', ' + objAddress.postalcode;
    }
    return (address.replace(/,\s*$/, ''));
  }

  numberFormat(val: any) {
    let type = typeof val;
    let length = val.length;
    let revVal = '';
    
    if (type == "string") {
      val = val.includes('_') ? val.replace('_', '-'):val;
      return val;
      // if (dir == 'rtl' && length > 1) {
      //   for (let i = length - 1; i >= 0; i--) {
      //     revVal += val[i];
      //   }
      //   revVal = revVal.includes('_') ? revVal.replace('_', '-'):revVal;
      //   return revVal;
      // }
      // else{
      //   val = val.includes('_') ? val.replace('_', '-'):val;
      //   return val;
      // }
    } else {
      return val;
    }
  }

  getContactLink(item: any): string {
    if (item.type === 'Whatsapp' || item.type === 'WhatsApp') {
      const cleanedNumber = item.mobile ? item.mobile.toString().replace(/\D/g, '') : '';
      return cleanedNumber ? `https://wa.me/${cleanedNumber}` : '#';
    }
    return `tel:${item.mobile}`;
  }

  getGoogleMapsEmbedUrl(location: string): SafeResourceUrl | null {
    if (!location || location.trim() === '') {
      return null;
    }

    let embedUrl: string = '';

    if (location.includes('/maps/embed')) {
      embedUrl = location;
    } else {
      try {
        const url = new URL(location);
        
        if (url.hostname.includes('goo.gl') || url.hostname.includes('maps.app.goo.gl')) {
          return null;
        }
        else if (url.hostname.includes('google.com') && url.pathname.includes('/maps')) {
          const q = url.searchParams.get('q');
          const ll = url.searchParams.get('ll'); // lat,lng format
          const pathPlace = url.pathname.match(/\/place\/([^\/]+)/);
          
          if (q) {
            embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sus!4v0!5m2!1sen!2sus&q=${encodeURIComponent(q)}`;
          } else if (ll) {
            const [lat, lng] = ll.split(',');
            embedUrl = `https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d0!2d${lng}!3d${lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v0!5m2!1sen!2sus`;
          } else if (pathPlace) {
            const placeName = decodeURIComponent(pathPlace[1].replace(/\+/g, ' '));
            embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sus!4v0!5m2!1sen!2sus&q=${encodeURIComponent(placeName)}`;
          } else {
            embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sus!4v0!5m2!1sen!2sus&q=${encodeURIComponent(location)}`;
          }
        } else {
          embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sus!4v0!5m2!1sen!2sus&q=${encodeURIComponent(location)}`;
        }
      } catch (e) {
        embedUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d0!3d0!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sus!4v0!5m2!1sen!2sus&q=${encodeURIComponent(location)}`;
      }
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  getHeadlineForLanguage(personalItems: any[], langCode: string): string {
    if (!Array.isArray(personalItems)) return '';
    const match = personalItems.find((item: any) => item.language === langCode && item.headline);
    return match ? match.headline : '';
  }

  getPersonalEntryForLanguage(personalItems: any[], langCode: string): any | null {
    if (!Array.isArray(personalItems)) return null;
    return personalItems.find((item: any) => item.language === langCode) ?? null;
  }

  getImageDescTitleForLanguage(imageDescItems: any[], langCode: string): string {
    if (!Array.isArray(imageDescItems)) return '';
    const match = imageDescItems.find((item: any) => item.language === langCode);
    return match?.title ?? '';
  }

  hasLocation(item: any): boolean {
    return item && item.location && item.location.trim() !== '';
  }

  isShortUrl(location: string): boolean {
    if (!location) return false;
    try {
      const url = new URL(location);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (e) {
      return false;
    }
  }

  getCardBackgroundStyle(cardDetails: any, basicColor: string): Record<string, string> {
    const appearance = this.appearanceOf(cardDetails);
    const font = String(appearance['font'] ?? UtilityService.APPEARANCE_DEFAULTS.font);
    const fontStack = `${font}, sans-serif`;
    const bgColor = String(appearance['background_colour'] ?? basicColor);

    if (this.colourType(appearance, 'background_colour') === 'gradient') {
      const img = this.gradientCssTrimmed(appearance, 'background_colour');
      if (img) {
        return {
          'background-image': img,
          'background-color': 'transparent',
          'font-family': fontStack,
        };
      }
    }

    return {
      'background-color': bgColor,
      'background-image': 'none',
      'font-family': fontStack,
    };
  }

  getPrimaryThemeType(cardDetails: any): string {
    return this.colourType(this.appearanceOf(cardDetails), 'primary_theme_colour');
  }

  getPrimaryThemeStyle(cardDetails: any, basicColor: string): Record<string, string> {
    const appearance = this.appearanceOf(cardDetails);
    const bgColor = String(appearance['primary_theme_colour'] ?? basicColor);
    const color = String(appearance['button_text_colour'] ?? UtilityService.APPEARANCE_DEFAULTS.buttonText);

    if (this.colourType(appearance, 'primary_theme_colour') === 'gradient') {
      const img = this.gradientCssTrimmed(appearance, 'primary_theme_colour');
      if (img) {
        return {
          'background-image': img,
          'background-color': 'transparent',
          color,
        };
      }
    }

    return {
      'background-color': bgColor,
      'background-image': 'none',
      color,
    };
  }

  getPrimaryGradientColor(cardDetails: any): Record<string, string> {
    const appearance = this.appearanceOf(cardDetails);
    const css = this.gradientCssTrimmed(appearance, 'primary_theme_colour');
    const d = UtilityService.APPEARANCE_DEFAULTS;
    if (css) {
      const { start, end } = this.colorsFromGradientCss(css, d.gradientFallbackStart, d.gradientFallbackEnd);
      return { 'start-color': start, 'end-color': end };
    }
    return {
      'start-color': String(appearance['primary_theme_colour_gradient_start'] ?? d.gradientFallbackStart),
      'end-color': String(appearance['primary_theme_colour_gradient_end'] ?? d.gradientFallbackEnd),
    };
  }

  getPrimaryThemeColor(cardDetails: any, basicColor: string): string {
    const appearance = this.appearanceOf(cardDetails);
    if (this.colourType(appearance, 'primary_theme_colour') !== 'gradient') {
      return String(appearance['primary_theme_colour'] ?? basicColor);
    }
    const css = this.gradientCssTrimmed(appearance, 'primary_theme_colour');
    if (css) {
      const first = this.firstColorFromGradientCss(css);
      if (first) return first;
    }
    return String(
      appearance['primary_theme_colour_gradient_start'] ?? appearance['primary_theme_colour'] ?? basicColor
    );
  }

  getPrimaryTextColor(cardDetails: any): string {
    return String(
      this.appearanceOf(cardDetails)['primary_text_colour'] ?? UtilityService.APPEARANCE_DEFAULTS.primaryText
    );
  }

  getSecondaryTextColor(cardDetails: any): string {
    return String(
      this.appearanceOf(cardDetails)['secondary_text_colour'] ?? UtilityService.APPEARANCE_DEFAULTS.secondaryText
    );
  }

  getSecondaryThemeStyle(cardDetails: any, basicColor: string): Record<string, string> {
    const stroke = this.getSecondaryThemeColor(cardDetails, basicColor);
    const base: Record<string, string> = {
      'background-image': 'none',
      'border-color': stroke,
      color: stroke,
    };

    // const appearance = this.appearanceOf(cardDetails);
    // if (appearance['secondary_theme_colour_type'] === 'gradient') {
    //   const img = this.gradientCssTrimmed(appearance, 'secondary_theme_colour');
    //   if (img) {
    //     return { ...base, 'background-image': img };
    //   }
    // }
    return base;
  }

  getSecondaryThemeColor(cardDetails: any, basicColor: string): string {
    const appearance = this.appearanceOf(cardDetails);
    const css = this.gradientCssTrimmed(appearance, 'secondary_theme_colour');
    if (css) {
      const first = this.firstColorFromGradientCss(css);
      if (first) return first;
    }
    return String(appearance['secondary_theme_colour'] ?? this.getPrimaryThemeColor(cardDetails, basicColor));
  }

  getButtonTextColor(cardDetails: any): string {
    return String(
      this.appearanceOf(cardDetails)['button_text_colour'] ?? UtilityService.APPEARANCE_DEFAULTS.buttonText
    );
  }

  isPrimaryButtonSolid(cardDetails: any): boolean {
    return Number(this.appearanceOf(cardDetails)['button_style'] ?? 0) === 1;
  }

  getAdditionalLinkButtonStyle(cardDetails: any, basicColor: string): Record<string, string> {
    const primary = this.getPrimaryThemeColor(cardDetails, basicColor);
    if (this.isPrimaryButtonSolid(cardDetails)) {
      return {
        ...this.getPrimaryThemeStyle(cardDetails, basicColor),
        'border-color': primary,
      };
    }
    return {
      'background-color': 'transparent',
      'background-image': 'none',
      'border-color': primary,
      color: primary,
    };
  }

  getAdditionalLinkTextStyle(cardDetails: any, basicColor: string): Record<string, string> {
    return {
      color: this.isPrimaryButtonSolid(cardDetails)
        ? this.getButtonTextColor(cardDetails)
        : this.getPrimaryThemeColor(cardDetails, basicColor),
    };
  }

  getProfileStatusHeightClass(cardDetails: any, currentPersonal: any, heightClass: string = 'h-[591px]'): string {
    return this.shouldApplyProfileStatusHeight(cardDetails, currentPersonal) ? heightClass : '';
  }

  shouldApplyProfileStatusHeight(cardDetails: any, currentPersonal: any): boolean {
    return Number(cardDetails?.profile_status) === 0
      && this.isBlankValue(currentPersonal?.firstName)
      && this.isBlankValue(currentPersonal?.lastName);
  }

  /** 8-digit hex with alpha suffix, e.g. `#0879C5` + `80` → `#0879C580` (matches `border-[#FFFFFF80]`). */
  hexColorWithAlpha(color: string, alphaHex: string = '80'): string {
    const trimmed = (color ?? '').trim();
    if (!trimmed) {
      return trimmed;
    }

    const hexMatch = trimmed.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})([0-9a-f]{2})?$/i);
    if (hexMatch) {
      let hex = hexMatch[1];
      if (hex.length === 3) {
        hex = hex.split('').map((c) => c + c).join('');
      }
      return `#${hex.toLowerCase()}${alphaHex.toLowerCase()}`;
    }

    const rgbaMatch = trimmed.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (rgbaMatch) {
      const alpha = Math.round((parseInt(alphaHex, 16) / 255) * 1000) / 1000;
      return `rgba(${rgbaMatch[1]}, ${rgbaMatch[2]}, ${rgbaMatch[3]}, ${alpha})`;
    }

    return trimmed;
  }

  private appearanceOf(cardDetails: any): Record<string, unknown> {
    return (cardDetails?.setting?.appearance ?? {}) as Record<string, unknown>;
  }

  /** Gradient CSS wins over stored `_type` when both solid and gradient fields exist in API data. */
  private colourType(appearance: Record<string, unknown>, prefix: string): 'solid' | 'gradient' {
    if (this.gradientCssTrimmed(appearance, prefix)) {
      return 'gradient';
    }
    return appearance[`${prefix}_type`] === 'gradient' ? 'gradient' : 'solid';
  }

  private isBlankValue(value: unknown): boolean {
    return String(value ?? '').trim() === '';
  }

  /** Non-empty trimmed gradient CSS, or null */
  private gradientCssTrimmed(appearance: Record<string, unknown>, prefix: string): string | null {
    const v = appearance[`${prefix}_gradient_css`];
    const s = (v ?? '').toString().trim();
    return s.length ? s : null;
  }

  private firstColorFromGradientCss(css: string): string {
    const colors = (css ?? '').match(UtilityService.GRADIENT_COLOR_TOKEN);
    return colors?.[0] ?? '';
  }

  private colorsFromGradientCss(css: string, fallbackStart: string, fallbackEnd: string): { start: string; end: string } {
    const colors = (css ?? '').match(UtilityService.GRADIENT_COLOR_TOKEN) ?? [];
    return {
      start: colors[0] || fallbackStart,
      end: colors[1] || colors[0] || fallbackEnd,
    };
  }

}
